export const questionsSelector = (state) => state.questionnaire.questions;
export const disclamerQuestionnaireSelector = (state) =>
  state.questionnaire.initalText;
export const currentStepQuestionnaireSelector = (state) =>
  state.questionnaire.currentStep;

export const answersQuestionnaireSelector = (state) =>
  state.questionnaire.answers;

export const surveyIdQuestionnaireSelector = (state) =>
  state.questionnaire.surveyId;

export const shouldShowAlmostExpQuestAlertSelector = (state) =>
  state.questionnaire.shouldShowAlmostExpQuestAlert;

export const shouldShowExpQuestAlertSelector = (state) =>
  state.questionnaire.shouldShowExpQuestAlert;

export const isDirtyQuestionnaireSelector = (state) =>
  state.questionnaire.isDirty;
